import { MdError } from '@teamworksdev/icons';
import { cn } from '../utils';

export const ErrorIcon = ({ className }: { className?: string }) => (
  <MdError className={cn('text-red-600 h-5 w-5', className)} />
);
